import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { BgColorOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG, ICmsComponentCwvConfig } from '../../../../config/component.config';

export interface PageComponentImageWithCopyBannerComponentData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
    image: string;
    background_color?: string;
    intro?: string;
    title?: string;
    cta_text?: string;
    cta_link?: string;
}

@ICmsComponent<PageComponentImageWithCopyBannerComponent>({
    id: 'image-with-copy-banner',
    name: 'Image with copy banner',
    tags: ['Banner'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.label,
            key: 'general',
            title: 'General'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'background_color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Background Color',
            options: BgColorOptions,
            colorPreview: true
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'intro',
            title: 'Intro'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'cta_text',
            title: 'CTA text'
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'cta_link',
            title: 'CTA link'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
})
@Component({
    selector: 'page-component-image-with-copy-banner',
    templateUrl: './image-with-copy-banner.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentImageWithCopyBannerComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: PageComponentImageWithCopyBannerComponentData;
}
